export default __webpack_public_path__ + "static/media/phone.69b621fb.png";